import { keyframes } from 'styled-components'

import { Loader } from './Loader'
import type { Options } from './Options'

export const stepWizardDefaultAnimations: Options['animations'] = {
	forward: {
		in: {
			keyframes: keyframes`
				0% {
					opacity: 0;
					transform: none;
				}
				/** This is a hack to make Android not initially assume that the content is offset by 10%, thus selecting items incorrectly. */
				0.5% {
					opacity: 0;
					transform: translate(10%);
				}

				100% {
					opacity: 1;
					transform: none;
				}
			`,
			duration: 0.15,
			delay: 0.15,
		},
		out: {
			keyframes: keyframes`
				0% {
					opacity: 1;
					transform: none;
				}

				100% {
					opacity: 0;
					transform: translate(-30%);
				}
			`,
			duration: 0.25,
		},
	},
	backward: {
		in: {
			keyframes: keyframes`
				0% {
					opacity: 0;
					transform: none;
				}
				/** This is a hack to make Android not initially assume that the content is offset by 10%, thus selecting items incorrectly. */
				0.5% {
					opacity: 0;
					transform: translate(-10%);
				}

				100% {
					opacity: 1;
					transform: none;
				}
			`,
			duration: 0.15,
			delay: 0.15,
		},
		out: {
			keyframes: keyframes`
				0% {
					opacity: 1;
					transform: none;
				}

				100% {
					opacity: 0;
					transform: translate(30%);
				}
			`,
			duration: 0.25,
		},
	},
}

export const stepWizardDefaultLoader: Options['loader'] = {
	delay: 0.8,
	duration: 0.45,
	Component: Loader,
}

export const stepWizardDefaultOptions: Options = {
	animations: stepWizardDefaultAnimations,
	loader: stepWizardDefaultLoader,
}
